import type { IBaseComponentProps } from 'components/base/types'
import { useTweenedString } from '@/utils/hooks/useTweenedString'
import { computed, defineComponent, type FunctionalComponent, type VNode } from 'vue'

interface IDisplayCellProps {
  title: {
    text?: string
    class?: string
    icon?: VNode
    component?: FunctionalComponent<IBaseComponentProps>
  }
  subtitle?: {
    text: string
    class?: string
  }
}

const DisplayCell = defineComponent<IDisplayCellProps>({
  setup(props) {
    const subtitleText = computed(() => props.subtitle?.text || '');
    const titleText = computed(() => props.title?.text || '');
    const tweenedText = useTweenedString({
      value: subtitleText,
      duration: 1
    });

    const tweenedTitle = useTweenedString({
      value: titleText,
      duration: 1
    });

    return () => {



      // const titleClass = title.class ? title.class : "text-gray-900 "
      const titleClass = props.title.class ? props.title.class : 'text-gray-900'
      const titleIcon = props.title.icon ? props.title.icon : null

      return (
        <div class="flex flex-col gap-0.5 w-full">
          {props.title.component ? (
            <props.title.component class="flex flex-row items-center gap-1 text-xs font-semibold leading-[18px] " />
          ) : (
            <div
              class={
                'flex flex-row items-center gap-1 text-xs font-semibold leading-[18px] ' +
                titleClass
              }
            >
              {titleIcon} {tweenedTitle.value}
            </div>
          )}
          {props.subtitle && tweenedText.value && (
            <div class="text-gray-500 text-xs font-normal leading-[18px] whitespace-nowrap">
              {tweenedText.value}
            </div>
          )}
        </div>
      )
    }
  }
})
DisplayCell.props = ['title', 'subtitle']
export default DisplayCell
